// extracted by mini-css-extract-plugin
module.exports = {"product":"Product_product__Cfq2I","productItem":"Product_productItem__N7M7q","fa-arrow-forward":"Product_fa-arrow-forward__eZwPP","cardImg":"Product_cardImg__2oTsD"};